<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">商品管理</el-breadcrumb-item>
				<el-breadcrumb-item>商品分类</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 搜索筛选 -->
		<el-form :inline="true" class="user-search" size="small">

			<el-form-item>
				<el-button size="small" type="danger" icon="el-icon-plus" @click="handleadd">添加</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="cateid" border
			:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
			<el-table-column prop="catename" label="商品分组信息" sortable width="180"> </el-table-column>

			<!-- <el-table-column prop="creatTime" label="订单时间" width="200" align="center">
        <template slot-scope="scope">
          <div>{{web.formatTime(scope.row.creatTime,'Y-M-D h:m')}}</div>
        </template>
      </el-table-column> -->
			<el-table-column prop="catename" label="排序" sortable width="180"> </el-table-column>
			<el-table-column prop="isHidden" label="是否隐藏">
				<template slot-scope="scope">
					<div>{{scope.row.isHidden==1?'隐藏':'未隐藏'}}</div>
				</template>
			</el-table-column>


			<el-table-column align="center" label="操作" min-width="300">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" icon="el-icon-edit"
						@click="handleEdit(scope.$index, scope.row)">编辑
					</el-button>

					<el-button size="mini" type="danger" icon="el-icon-delete"
						@click="handledelete(scope.$index, scope.row)">删除
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页组件 -->


		<!-- 新增弹窗 -->
		<el-dialog       :close-on-click-modal="false" title="编辑" :visible.sync="Visible" width="40%"
			@click="closeDialog" center>

			<el-form class="user-search" label-width="100px" inline size="small" :model="editForm" :rules="rules"
				ref="editForm">
				<el-form-item label="上级：">
					<el-cascader v-model="value" :options="tableData"
						:props="{checkStrictly: true, label: 'catename' , value: 'cateid'}" clearable
						@change="changecascader">

					</el-cascader>
				</el-form-item>
				<el-form-item label="类名：" :rules="rules.input" prop="catename">
					<el-input size="small" placeholder="请输入新增类名" v-model="editForm.catename"></el-input>
				</el-form-item>
				<el-form-item label="未激活图:">
					<!-- <unload @upload="upload" cateName="noactive" :limit="1" methods="down"></unload> -->
					<uploadone :url="cateImg" cateName="noactive" @click="uploadone" csssize="100px">
					</uploadone>
				</el-form-item>
				<el-form-item label="激活图:">
					<!-- <unload @upload="upload"  cateName="active" :limit="1" methods="down"></unload> -->

					<uploadone :url="cateImgSelected" cateName="active" @click="uploadone" csssize="100px">
					</uploadone>
				</el-form-item>
				<el-form-item label="是否隐藏:">
					<el-radio-group v-model="isHidden">
						<el-radio-button label="0">显示</el-radio-button>
						<el-radio-button label="1">隐藏</el-radio-button>

					</el-radio-group>
				</el-form-item>



				<el-form-item label="类型" :rules="rules.select" prop="type">
					<el-select v-model="editForm.type">
						<el-option label="首页" value='index'></el-option>
						<el-option label="商品" value='goods'></el-option>
						<el-option label="积分" value='point'></el-option>
						<el-option label="活动" value='activity'></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="选择商品:" v-show="editForm.type=='index'|| editForm.type=='activity'"
					style="width: 100%;">
					<el-checkbox-group v-model="goodsIds" @change="handleCheckedCitiesChange">
						<el-checkbox v-for="(item,index) in products" :label="item.goodsId" :key="index">
							{{item.goodsName}}</el-checkbox>
					</el-checkbox-group>
				</el-form-item>

				<div>
					<el-form-item label="开始时间:" v-show=" editForm.type=='activity'">
						<datatime v-model="activityStartTime" catename="activityStartTime"></datatime>
					</el-form-item>
					<el-form-item label="结束时间:" v-show=" editForm.type=='activity'">
						<datatime v-model="activityEndTime" catename="activityEndTime"></datatime>
					</el-form-item>
				</div>

			</el-form>


			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeDialog">取消</el-button>
				<el-button size="small" type="primary" :loading="loading" class="title"
					@click="addCategory('editForm')">保存</el-button>
			</div>
		</el-dialog>
		<!-- <unload2 @upload2="upload2"  ></unload2> -->
	</div>
</template>
<script>
	import {
		getAllCategory,
		deleteCategory,
		addEditCategory,
		getSaleGoods
	} from '../../api/basisMG.js'
	import ruleMixin from '@/utils/ruleMixin'
	// 导出模块
	export default {
		mixins: [ruleMixin],
		data() {
			return {
				editForm: {
					catename: '',
				},
				type: '',
				fileList: [],
				products: [],
				goodsIds: [],
				showIdnex: 0,
				loading: false,
				tableData: [],
				value: [],
				Visible: false,
				parentid: '',
				catename: '',
				cateImg: '',
				cateImgSelected: '',
				isHidden: 0,
				activityStartTime: '',
				activityEndTime: '',
				// 分页参数
				pageparm: {
					currentPage: 1,
					pageSize: 5,
					total: 10,
					start: 0,
					length: 5,
					cateid: ''
				},
			}
		},
		created() {
			this.getParams(this.$route.path)
			this.getCategory()
			this.getGoods()

		},

		methods: {

			handleCheckedCitiesChange(value) {

				console.log('handleCheckedCitiesChange', value)

			},
			closeDialog() {
				this.Visible = false
			},
			upload(data, cateName) {
				let name = cateName
				if (name == "noactive") {
					this.cateImg = data
				} else {
					this.cateImgSelected = data

				}
				console.log(this.cateImg)
				console.log(this.cateImgSelected)
			},
			// 单个上传图
			uploadone(data, cateName) {
				let name = cateName
				if (name == "noactive") {
					this.cateImg = data
				} else {
					this.cateImgSelected = data
				}
			},
			// 分页插件事件
			callFather(parm) {
				this.pageparm.currentPage = parm.currentPage
				this.pageparm.pageSize = parm.pageSize
				this.pageparm.start = parm.currentPage - 1
				this.pageparm.length = parm.pageSize
				this.formInline.start = parm.currentPage - 1
				this.formInline.length = parm.pageSize
				this.getdata(this.formInline)

			},
			changecascader(e) {
				console.log(e)

			},
			handleEdit(index, row) {
				console.log('handleEdit', index, row)
				this.parentid = [row.parentid]
				this.value = [row.parentid]
				if (row.goodsIds) {
					let arr = row.goodsIds.split(',')
					console.log(arr)
					for (let i = 0; i < arr.length; i++) {
						let result = this.products.findIndex((item) => {
							return item.goodsId == arr[i]
						})
						if (result != -1) {
							this.goodsIds.push(Number(arr[i]))
						}
					}
					console.log(this.goodsIds)
					// this.goodsIds = row.goodsIds.split(',')
					//   arr.forEach((element,index) => {

					//     this.goodsIds[index]=Number(element)
					// })
				}

				this.editForm = Object.assign({}, row)
				this.catename = row.catename
				this.cateImg = row.cateImg
				this.cateImgSelected = row.cateImgSelected
				this.isHidden = row.isHidden
				this.cateid = row.cateid
				this.activityStartTime = row.activityStartTime
				this.activityEndTime = row.activityEndTime
				console.log(this.parentid)
				this.Visible = true
			},
			handleadd() {
				this.parentid = null
				this.catename = ''
				this.editForm.catename = ''
				this.cateImg = ''
				this.cateImgSelected = ''
				this.isHidden = 0
				this.cateid = ''
				this.activityStartTime = ''
				this.activityEndTime = ''
				this.Visible = true
			},
			addCategory(formName) {
				console.log(formName)
				// this.$refs[formName].validate((valid) => {
				//   console.log(valid)
				//   if (valid) {
				let length = this.value.length
				let param = {
					parentid: this.value[length - 1],
					catename: this.editForm.catename,
					cateImg: this.cateImg,
					cateImgSelected: this.cateImgSelected,
					isHidden: this.isHidden,
					goodsIds: this.goodsIds.join(','),
					// goodsIds:'',
					cateid: this.cateid,
					type: this.editForm.type,
					activityStartTime: this.activityStartTime,
					activityEndTime: this.activityEndTime
				}
				let that = this
				console.log(param)
				addEditCategory(param).then(res => {
					console.log(res.code)
					if (res.code == 200) {
						that.$message({
							type: 'success',
							message: '添加成功'
						})
						//  this.web.message('添加成功','success')
						that.getCategory()
						that.Visible = false
						this.value = []
						this.catename = ''
						this.editForm.catename = ''
						this.cateImg = ''
						this.cateImgSelected = ''
						this.isHidden = 0
						this.goodsIds = []
						this.activityStartTime = ''
						this.activityEndTime = ''
						// console.log('addCategory',res)
					}

				})
				//   }
				// })


			},
			reply() {},
			handledelete(index, row) {
				console.log(index, row)
				deleteCategory({
					cateid: row.cateid
				}).then(res => {
					console.log(res)
					if (res.code == 200) {
						this.$message({
							type: 'success',
							message: '删除成功'
						})
						this.getCategory()
					}

				})
			},
			// 获得在售商品
			getGoods() {
				getSaleGoods().then(res => {
					if (res.code == '200') {
						this.products = res.data
					}
				})
			},
			getCategory() {
				//   获得商品分类列表
				getAllCategory().then(res => {
					if (res.code == '200') {
						this.tableData = this.formateChildren(res.data)
					}

				})
			},
			formateChildren(data) {
				if (data.length) {
					data.map(element => {
						if (element.children && element.children.length > 0) {
							this.formateChildren(element.children)
						} else {
							delete element.children
						}
					});
				}
				return data
			},

		},
	}
</script>
<style scoped>
	.el-form-item {
		width: 45%;
	}
</style>
